import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicbreed'
})
export class DynamicbreedPipe implements PipeTransform {
  transform(data: any, type: any): any {
   
    if (!type){
      return data;
    } 
    else{
      var out =[];
    for(let d in data){
       if(data[d].parent_id==type){
            out.push(data[d]);
          }
    }
    return out;
    }
  }
}
